import React from 'react';
import PropTypes from 'prop-types';

import {
  SVGIcon,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import {
  IconLeft,
  IconRight,
  SubscriptionPlaceholder,
  SubscriptionInner,
  SubscriptionContent,
} from '../styles';

const SubscriptionPlaceholderComponent = ({ onClick, workspaceName }) => (
  <SubscriptionPlaceholder onClick={onClick}>
    <SubscriptionInner>
      <SubscriptionContent>
        <IconLeft>
          <SVGIcon
            icon="duotoneStudent"
          />
        </IconLeft>
        {
          workspaceName
        }
      </SubscriptionContent>
      <IconRight>
        <MaterialIcon id={'keyboard_arrow_up'} />
      </IconRight>
    </SubscriptionInner>
  </SubscriptionPlaceholder>
);

SubscriptionPlaceholderComponent.propTypes = {
  onClick: PropTypes.func,
  workspaceName: PropTypes.string,
};

export default SubscriptionPlaceholderComponent;
